
import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'


const HeaderLogo = () => {
    const clientlogo = useSelector(state => state.clientlogo.entities)
    const clientLogoStatus = useSelector(state => state.clientlogo.status)
    

    useEffect(() => {

    }, [clientLogoStatus])


    return (
        <Box>
            <Link to={clientlogo.ClientLogoExternalLink ? clientlogo.ClientLogoExternalLink : "/home"}>

                <img style={{ maxWidth: '95%', maxHeight: '100px' }} src={"../" + clientlogo.ClientLogoSource + '/'} alt={clientlogo.ClientLogoAltText} id="logo-image"></img>
            </Link>

        </Box>
    )
}

export default HeaderLogo